import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  paper: {
    padding: '24px 32px',
    background: palette.gradients.white,
    height: '111px'
  }
});
export default useStyles;